import { render, staticRenderFns } from "./AutomatedReportTable.vue?vue&type=template&id=4e59b2fa"
import script from "./AutomatedReportTable.vue?vue&type=script&lang=ts"
export * from "./AutomatedReportTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports